import { defineStore, acceptHMRUpdate } from 'pinia';
import { getUsers } from '../scripts/customers'

export const useUsers = defineStore('users', {
    state: () => ({
        fetchedUsers: [],
        loading: true
    }),
    actions: {
        async getUsers(){
            this.loading = true

            try {

                const list = await getUsers()

                if (list && list.length > 0) {
                    this.fetchedUsers = list
                } else {
                    this.fetchedUsers = []
                    this.loading = false
                    return false
                }

                return true

            } catch (error) {
                console.error(error)
                return false
            } finally {
                this.loading = false
            }
        }
    },
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useUsers, import.meta.hot))
}